import { EpimsBaseEntityDto } from './epim-base.dto';
export class PoleDto extends EpimsBaseEntityDto {
  PoleName: string;
  SubscriptionUserId: string;
  Version: number;
}
